import { AttachmentParagraphT } from 'types/shared/core/Post';
import { IconButton, Stack, styled, Typography } from '@mui/material';
import interfaceBridge from 'utils/interfaceBridge';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Config from 'config/Config';

type PostContentAttachmentPropsT = {
  paragraph: AttachmentParagraphT;
};

const StyledAttachmentParagraph = styled('div')<{}>`
  padding: 0px 16px;
  & > div {
    padding: 16px;
    display: block;
    background-color: ${(props) => props.theme.palette.action.hover};
  }

  & > div {
    position: relative;
    overflow: hidden;
  }
`;

function PostContentAttachment({ paragraph }: PostContentAttachmentPropsT) {
  const handleClick = () => {
    const baseUrl = `${Config.fileServerBaseUrl}${Config.contentAttachmentPathPrefix}`;

    const url = `${baseUrl}${paragraph.path}`;
    console.log('attachment url=', url);

    interfaceBridge.downloadFile(url, paragraph.fileName, 'etc');
  };

  return (
    <StyledAttachmentParagraph onClick={handleClick}>
      <div>
        <Stack direction="row" justifyContent="center" alignItems="center">
          <IconButton>
            <AttachFileIcon color="primary" />
          </IconButton>
          <Typography
            variant="body1"
            color={
              paragraph.uploadStatus === 'complete'
                ? 'textPrimary'
                : 'textSecondary'
            }
            sx={{ flex: 1, display: 'inline-block' }}
          >
            {paragraph.fileName}
          </Typography>
        </Stack>
      </div>
    </StyledAttachmentParagraph>
  );
}
export default PostContentAttachment;
